import React, {Fragment, useState} from 'react';
import {DI} from 'modules';
import Component from 'components/component';
import From from 'common/components/form/new-form';
import * as routes from 'config/routes';
import {Link} from 'components/link';
import {TextInputField} from 'components/form/text-input';
// import InvisibleRecaptcha from 'components/invisible-recaptcha';
import {ModalAuth} from './modalAuth';
import config from 'config';

export function FormSignIn(props) {
  // const recaptchaRef = React.createRef();
  const {onClose = () => {}} = props;
  const [form, setForm] = useState({
    email: props.common.signInModal.email,
    password: '',
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const onRecaptchaPassed = (result) => {
    props.actions.user
      .signIn(form)
      .then((resp) => {
        resp, onClose();
      })
      .catch((err) => {
        const {body} = err.response;
        setLoading(false);
        if (body && body.errors) {
          const errors = body.errors
            .map((error) => (props.common.strings[error.code] ? props.common.strings[error.code] : error.code))
            .filter(Boolean);

          setErrors(errors);
          switch (errors.toString()) {
            case 'user_need_2FA':
              props.actions.common.openAuthModal();
              break;
            case 'User is deactivated':
              onClose();
              break;
            default:
              break;
          }
        }
        throw err;
      });
  };

  const onChange = (ev, form) => {
    setErrors([]);
    setForm(form);
  };
  const onSubmit = (ev, form) => {
    setLoading(true);
    onRecaptchaPassed();
    // recaptchaRef.current.execute(config.RECAPTCHA_KEY, {
    //     action: 'defaultAction'
    // })
  };

  const closeModal = () => {
    props.actions.common.closeAuthModal();
  };

  const {strings} = props.common;
  const buttonClassName = Component.classList('button button--free', loading && '_waiting');
  const signInFormClassName = Component.classList('sign-in-form j-terms', loading && '_loading');

  const oauth = (type) => {
    if (type === 'facebook') {
      window.location.assign(`${config.API_HOST}/users/auth/facebook`);
    }
    if (type === 'google') {
      window.location.assign(`${config.API_HOST}/users/auth/google_oauth2`);
    }
    if (type === 'twitter') {
      window.location.assign(`${config.API_HOST}/users/auth/twitter`);
    }
  };

  return (
    <Fragment>
      <span className="sign-in__title">{strings['signin.title']}</span>
      <div className="sign-in-text sign-in-text--pre">
        <p>{strings['signin.text']}</p>
      </div>
      <div className={signInFormClassName}>
        <From onChange={onChange} onSubmit={onSubmit}>
          <TextInputField
            isEmail
            name="email"
            title={strings['signin.email.placeholder']}
            type="email"
            value={form.email}
          />
          <TextInputField
            autoComplete={'new-password'}
            isRequired
            name="password"
            title={strings['signin.password.placeholder']}
            type="password"
            value={form.password}
          />

          {errors.map((error) => (
            <div key={error} className="error">
              {error === 'user_need_2FA' ? strings['header.profile.two_auth.hint'] : error}
            </div>
          ))}

          <div className="field field--padded">
            <button type="submit" className={buttonClassName}>
              {strings['signin.button.text']}
            </button>
          </div>
        </From>
      </div>

      <div className="sign-in-social">
        <div className="sign-in-social__text">{strings['signin.social.pretitle']}</div>
        <a
          className="sign-in-social__button sign-in-social__button--facebook"
          href="#"
          onClick={() => oauth('facebook')}
        >
          {strings['signin.social.facebook']}
        </a>
        <a className="sign-in-social__button sign-in-social__button--twitter" href="#" onClick={() => oauth('twitter')}>
          {strings['signin.social.twitter']}
        </a>
        <a className="sign-in-social__button sign-in-social__button--google" href="#" onClick={() => oauth('google')}>
          {strings['signin.social.google']}
        </a>
      </div>
      <div className="sign-in-text">
        <p>
          <Link onClick={() => onClose()} to={routes.restorePassword.getPath()}>
            {strings['signin.forgot']}
          </Link>
        </p>
      </div>
      <div className="sign-in-text">
        <p>
          {props.openSignUpModal ? (
            <a href="#" onClick={props.openSignUpModal}>
              {strings['signin.signup']}
            </a>
          ) : (
            <Link to={routes.signup.getPath()}>{strings['signin.signup']}</Link>
          )}
        </p>
      </div>

      {props.common.AuthModal && <ModalAuth close={closeModal} confirm={onSubmit} />}
    </Fragment>
  );
}

export default DI(['user', 'recaptcha'])(FormSignIn);
